import { MapSettingEnum } from '../../../../../shared/GameEnums.ts';
import { MapDataController } from '../../../../../shared/map_data/MapDataController.ts';
import { createDivIn, createSpanIn, createLinkIn, setElementInnerHTML } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { UIUtilsEjsVariables } from '../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { UIMRoomCardView } from './UIMRoomCardView.ts';
import { ClientUserState } from '../../../../shared/scripts/ClientUserState.ts';
import { socket } from '../../../../shared/scripts/EntryShared.ts';
import { showMapInfoDialog } from '../../../../shared/scripts/ui_popup/showMapInfoDialog.ts';
import { ColonistMembershipPerkType } from '@colonist/lobby-types';
import { sendRoomBecomeAMemberAnalytic } from '../../../../shared/scripts/analytics/sendRoomBecomeAMemberAnalytic.ts';
import { openSubscriptionOverlayInsteadOfLinkInVariant } from '../../../../shared/scripts/store/subscription_overlay/subscriptionOverlayABTest.ts';
export class UIMRoomMapController {
    update(roomState) {
        this.refreshList(roomState);
        for (const card of this.cardList){
            const isSelected = roomState.gameSetting.mapSetting == card.mapData.mapEnum;
            card.element.setSelect(isSelected);
            if (isSelected) this.isSelectedMapAccessible = card.isMapAccessible;
        }
    }
    createMembershipCTA() {
        var _ClientUserState_userState;
        if (UIUtilsEjsVariables.shouldHideStoreOnMobile) return;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasMembership()) return;
        const membershipCTAContainer = createDivIn(this.container, 'room_center_become_a_member mobile-room');
        createSpanIn(membershipCTAContainer, '', {
            key: 'strings:roomPage.getAccessToAllMapsAndExpansions'
        });
        const becomeAMemberButton = createLinkIn(membershipCTAContainer, '/store#membership', {
            key: 'strings:homePage.becomeAMember'
        }, 'btn_general btn_general_no_margin btn_general_orange btn-general-become-a-member', '', true);
        openSubscriptionOverlayInsteadOfLinkInVariant(becomeAMemberButton);
        // eslint-disable-next-line no-restricted-syntax
        becomeAMemberButton.addEventListener('click', ()=>sendRoomBecomeAMemberAnalytic());
    }
    createAllCards(roomState) {
        const compatibleMaps = [
            ...MapDataController.getMapDataCompatibleWithGameMode(roomState.gameSetting.modeSetting)
        ];
        UIMRoomMapController.sortMapsByOwnership(compatibleMaps);
        const weeklyFreeMap = compatibleMaps.find((mapData)=>UIMRoomMapController.shouldShowWeeklyFreeBanner(mapData));
        if (weeklyFreeMap) {
            const weeklyFreeMapIndex = compatibleMaps.indexOf(weeklyFreeMap);
            const weeklyFreeMapData = compatibleMaps[weeklyFreeMapIndex];
            compatibleMaps.splice(weeklyFreeMapIndex, 1);
            compatibleMaps.splice(1, 0, weeklyFreeMapData);
        }
        for (const mapData of compatibleMaps){
            var _ClientUserState_userState;
            if (!mapData.isActive) continue;
            const mapTitle = UIMRoomMapController.getMapDisplayText(mapData);
            const clickAction = ()=>{
                socket.roomClient.setMap(mapData.mapEnum);
            };
            const displayInfoAction = ()=>showMapInfoDialog(mapData);
            const canUserAccessMap = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasAccessToPremiumMap(mapData);
            const isMapFree = UIMRoomMapController.addFreeAfterMapName(mapData);
            const shouldShowWeeklyFreeBanner = UIMRoomMapController.shouldShowWeeklyFreeBanner(mapData);
            const isCardLocked = !canUserAccessMap && !isMapFree;
            if (isCardLocked && UIUtilsEjsVariables.shouldHideStoreOnMobile) continue;
            const card = new UIMRoomCardView(this.container, mapTitle, mapData.image, isCardLocked, true, clickAction, displayInfoAction);
            if (shouldShowWeeklyFreeBanner) card.createBanner({
                key: 'strings:roomPage.options.map.weeklyFree'
            });
            this.cardList.push({
                mapData: mapData,
                element: card,
                isMapAccessible: !isCardLocked
            });
        }
        this.update(roomState);
    }
    static sortMapsByOwnership(maps) {
        maps.sort((a, b)=>{
            var _ClientUserState_userState, _ClientUserState_userState1;
            var _ClientUserState_userState_items_hasAccessToPremiumMap;
            const aAccessible = (_ClientUserState_userState_items_hasAccessToPremiumMap = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasAccessToPremiumMap(a)) !== null && _ClientUserState_userState_items_hasAccessToPremiumMap !== void 0 ? _ClientUserState_userState_items_hasAccessToPremiumMap : false;
            var _ClientUserState_userState_items_hasAccessToPremiumMap1;
            const bAccessible = (_ClientUserState_userState_items_hasAccessToPremiumMap1 = (_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.items.hasAccessToPremiumMap(b)) !== null && _ClientUserState_userState_items_hasAccessToPremiumMap1 !== void 0 ? _ClientUserState_userState_items_hasAccessToPremiumMap1 : false;
            if (aAccessible === bAccessible) return 0;
            return aAccessible ? -1 : 1;
        });
    }
    static addFreeAfterMapName(mapData) {
        const isBaseMap = mapData.mapEnum == MapSettingEnum.Classic4P;
        if (isBaseMap) return false;
        const isWeeklyFreeMap = mapData.mapEnum == UIUtilsEjsVariables.freeMap;
        if (isWeeklyFreeMap) return true;
        if (!mapData.isMapPremium()) return true;
        return false;
    }
    static getMapDisplayText(mapData) {
        switch(mapData.mapEnum){
            case MapSettingEnum.Classic56P:
                return {
                    key: 'strings:colonistCommon.gameMaps.classic.56P.abbreviation'
                };
            case MapSettingEnum.Classic78P:
                return {
                    key: 'strings:colonistCommon.gameMaps.classic.78P.abbreviation'
                };
            default:
                return mapData.name;
        }
    }
    static shouldShowWeeklyFreeBanner(mapData) {
        var _ClientUserState_userState;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.isPerkAvailable(ColonistMembershipPerkType.AllMaps)) return false;
        if (mapData.mapEnum == UIUtilsEjsVariables.freeMap) return true;
        return false;
    }
    refreshList(roomState) {
        if (this.lastGamemodeSelected == roomState.gameSetting.modeSetting) return;
        this.lastGamemodeSelected = roomState.gameSetting.modeSetting;
        setElementInnerHTML(this.container, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
        this.cardList.length = 0;
        this.createAllCards(roomState);
    }
    constructor(container, roomState){
        this.cardList = [];
        this.isSelectedMapAccessible = true;
        this.container = container;
        this.lastGamemodeSelected = roomState.gameSetting.modeSetting;
        this.createMembershipCTA();
        this.createAllCards(roomState);
    }
}
